import React, { useState } from "react";
import Button from "@mui/material/Button";
import GoogleAutoComplete from "./autoComplete";
import { components } from "react-select";
import { CircularProgress, Typography, useMediaQuery } from "@mui/material";
import { getOrdinal } from "../helper/helper";

const DynamicGoogleAutocompleteFields = ({
  coordinates,
  handlePlaceSelect,
  loading,
  addCoordinate,
  removeCoordinate,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const isMobile = useMediaQuery("(max-width:800px)");
  const handleInputFocus = (index) => {
    setActiveIndex(index);
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CircularProgress size={"20px"} />
      </components.DropdownIndicator>
    );
  };

  return (
    <div>
      {coordinates.map(({ address }, index) => (
        <div key={index} style={{ marginBottom: 10, marginTop: 10 }}>
          {/* <Typography color={"primary"} variant="body" my={1}>
            {getOrdinal(index + 1)} destination<sup>*</sup>
          </Typography> */}
          <GoogleAutoComplete
            key={index}
            selectProps={{
              components: activeIndex === index &&
                loading && { DropdownIndicator },
              isDisabled: loading,
              placeholder: `${getOrdinal(index + 1)} destination`,
              onChange: (selected) => {
                handlePlaceSelect(index, selected);
              },
              onFocus: () => handleInputFocus(index),
              onBlur: () => setActiveIndex(null),
              value: address !== null && {
                label: address,
                value: { place_id: "" },
              },
            }}
          />
          {index > 1 && (
            <span
              style={{ fontSize: "12px", cursor: "pointer", color: "#D20000" }}
              onClick={() => removeCoordinate(index)}
            >
              Remove Destination
            </span>
          )}
        </div>
      ))}
      <Button
        disabled={loading}
        variant="contained"
        color="primary"
        size="small"
        onClick={addCoordinate}
        sx={{
          border: 0,
          marginY: 2,
          boxShadow: "none",
          backgroundColor: "#e5e5ea !important",
          color: "#1B66B2 !important",
          "&:hover": {
            backgroundColor: isMobile
              ? "#e5e5ea !important"
              : "#1b66b2 !important",
            color: isMobile ? "#1B66B2 !important" : "#FFFFFF !important",
          },
        }}
      >
        {loading && <CircularProgress size={"20px"} />} &nbsp; Add Destination
      </Button>
    </div>
  );
};

export default DynamicGoogleAutocompleteFields;
